import AlternativesLayout from './Layout'

export default AlternativesLayout
